// Custom DOM events emitted by the widget. The host page binds analytics
// (GA4, etc.) to these — not to internal widget DOM. This is the stable
// integration surface defined in the embedding contract.
//
// See ../../../clubchampion-docs/architecture/widget-embedding-contract.md

export type StepName =
  | 'lead-capture'
  | 'location-search'
  | 'location-selected'
  | 'fitting-type'
  | 'date'
  | 'fitter'
  | 'time'
  | 'promo'
  | 'booking-confirmed'
  | 'get-set-up';

interface WidgetEventDetails {
  'cc:booking-widget:engaged': { source: string };
  'cc:booking-widget:step-changed': { step: StepName; value?: unknown };
  'cc:booking-widget:booking-confirmed': {
    confirmationNumber: string;
    bookingId: string;
    fittingType: string;
    location: string;
  };
  'cc:booking-widget:post-booking-completed': { bookingId: string };
  'cc:booking-widget:abandoned': { step: StepName };
}

export function emit<E extends keyof WidgetEventDetails>(
  name: E,
  detail: WidgetEventDetails[E],
): void {
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export const ENGAGE_EVENT = 'cc:booking-widget:engage';
